<template>
    <main>
        <nav class="navbar navbar-expand-md navbar-light navbar-laravel">
            <div class="container">
                <a @click="$router.go(-1)" class="navbar-brand icon-left">
                    {{ pageTitle }}
                </a>

                <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div
                    class="collapse navbar-collapse"
                    id="navbarSupportedContent"
                >
                    <!-- Left Side Of Navbar -->
                    <ul class="navbar-nav mr-auto"></ul>

                    <!-- Right Side Of Navbar -->
                    <ul class="navbar-nav ml-auto">
                        <!-- Authentication Links -->
                        <li v-if="!is_admin" class="nav-item">
                            <a class="nav-link icon-user" href="/login"
                                >Admin Login</a
                            >
                        </li>
                        <li v-if="is_admin" class="nav-item">
                            <router-link
                                :to="`/map/admin/`"
                                class="nav-link icon-map-o"
                            >
                                Admin Console
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link icon-qrcode" href="/showkey">
                                Show Map Link QR Code
                            </a>
                        </li>

                        <li v-if="$screenfull.enabled" class="nav-item">
                            <a
                                @click="
                                    collapseNav();
                                    $screenfull.toggle();
                                "
                                class="nav-link icon-resize-full"
                                href="#"
                            >
                                Toggle Full-Screen
                            </a>
                        </li>

                        <li v-if="this.$route.name == 'block'" class="nav-item">
                            <a
                                @click="setUiMode('view-dnc')"
                                class="nav-link icon-cancel-circle"
                                href="#"
                            >
                                Do Not Call List
                            </a>
                        </li>
                        <li
                            v-if="
                                this.$route.name == 'block' ||
                                    this.$route.name == 'map'
                            "
                            class="nav-item"
                        >
                            <a
                                class="nav-link icon-pencil-neg"
                                v-on:click="setUiMode('create-note')"
                                href="#"
                                data-toggle="collapse"
                                data-target="#div-create-note"
                            >
                                Leave a Note
                            </a>
                        </li>

                        <li v-if="is_admin" class="nav-item dropdown">
                            <a
                                id="navbarDropdown"
                                class="nav-link dropdown-toggle icon-user"
                                href="#"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                {{ user_name }} <span class="caret"></span>
                            </a>

                            <div
                                class="dropdown-menu dropdown-menu-right"
                                aria-labelledby="navbarDropdown"
                            >
                                <a
                                    class="dropdown-item"
                                    href="/logout"
                                    onclick="event.preventDefault();
                                                document.getElementById('logout-form').submit();"
                                >
                                    Logout
                                </a>

                                <form
                                    id="logout-form"
                                    action="/logout"
                                    method="POST"
                                    style="display: none;"
                                >
                                    <input
                                        type="hidden"
                                        name="_token"
                                        id="csrf-token"
                                        :value="csrf_token"
                                    />
                                </form>
                                <a class="dropdown-item" href="/password">
                                    Change Password
                                </a>
                                <a class="dropdown-item" href="/register"
                                    >Create New Administrator</a
                                >
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <div v-if="loadingData" class="loading-indicator" v-cloak>
            <h1 class="text-center" style="line-height:100px;">
                <span class="icon-spin4 animate-spin"></span>
                Loading...
            </h1>
        </div>

        <div class="container">
            <div v-if="errorMessage" class="row">
                <div class="col-md-12 mt-5 pt-5">
                    <h1 class="text-center text-danger icon-cancel-circle">
                        Application Error
                    </h1>
                    <h1 class="text-center text-danger">
                        {{ errorMessage }}
                    </h1>
                </div>
            </div>
            <olMap
                v-else
                left="0"
                top="55px"
                interactionType="Select"
                :showNewNote="uiMode == 'create-note'"
                :showNotes="true"
                @singleFeatureSelected="onMapSelect"
                @multiFeatureSelected="onMapDeselect"
                @noFeatureSelected="onMapDeselect"
                @newNoteMoved="onNewNoteMoved"
            ></olMap>

            <transition name="slide">
                <div
                    v-if="
                        $route.name == 'block' &&
                            uiMode == 'view-property-details'
                    "
                    id="property-details"
                    class="card"
                    style="position:fixed;top:55px;left:0px;width:100%;"
                >
                    <div class="card-body">
                        <div
                            @click="clearSelectionAndUiModeNone"
                            style="position:relative;"
                        >
                            <h4
                                class="icon-cancel"
                                style="position:absolute; right:0; top:0;font-size:largest;"
                            ></h4>
                            <div class="mb-3 text-center font-weight-bold">
                                {{ $store.getters.singleSelection.text }}
                            </div>
                        </div>

                        <button
                            v-show="!$store.getters.selectedDnc"
                            class="form-control btn btn-secondary"
                            role="button"
                            @click="setUiMode('create-dnc')"
                        >
                            Mark as DO NOT CALL
                        </button>

                        <div v-if="$store.getters.selectedDnc">
                            <div
                                class="mb-3 text-center font-weight-bold text-danger"
                            >
                                DO NOT CALL
                            </div>

                            <div
                                id="display-dnc-details"
                                class="mb-3 text-center"
                            >
                                {{ $store.getters.selectedDnc.details }}
                            </div>

                            <div
                                v-if="$store.getters.selectedDnc.approved == 0"
                                class="text-primary text-center font-weight-bold"
                            >
                                This DNC is awaiting approval by the map
                                administrator.
                            </div>
                            <div
                                v-else-if="
                                    $store.getters.selectedDnc.removed_by
                                "
                                id="div-removal-request-sent"
                                class="text-primary text-center font-weight-bold"
                            >
                                A request to remove this DNC has been sent to
                                the map administrator.
                            </div>
                            <button
                                v-else
                                class="form-control btn btn-primary"
                                id="btn-remove-dnc"
                                role="button"
                                @click="setUiMode('remove-dnc')"
                            >
                                Request DO NOT CALL Removal
                            </button>
                        </div>
                    </div>
                </div>
            </transition>

            <transition name="slide">
                <div
                    v-if="this.$route.name == 'block' && uiMode == 'create-dnc'"
                    class="card"
                    style="position:fixed;top:55px;left:0px;width:100%;"
                >
                    <div class="card-body">
                        <div class="text-center font-weight-bold">
                            Create DO NOT CALL
                        </div>
                        <div class="mb-3 text-center">
                            {{ $store.getters.singleSelection.text }}
                        </div>

                        <ajax-form
                            v-slot="{ model }"
                            :action="`/mapdata/${$store.getters.selectedId}`"
                            method="PUT"
                            :hidden-input="{ do_not_call: 1 }"
                            @cancel="clearSelectionAndUiModeNone"
                            @success="updateDnc"
                            @success-complete="clearSelectionAndUiModeNone"
                        >
                            <m-textarea
                                label="DNC Details:"
                                name="dnc_details"
                                :model="model"
                                placeholder="eg. Shift Worker"
                            ></m-textarea>
                        </ajax-form>
                    </div>
                </div>
            </transition>

            <transition name="slide">
                <div
                    v-if="uiMode == 'create-note'"
                    id="div-create-note"
                    class="card"
                    style="position:fixed;top:55px;left:0px;width:100%;"
                >
                    <div class="card-body">
                        <ajax-form
                            v-slot="{ model }"
                            action="/note"
                            method="POST"
                            :hidden-input="{
                                map_id: this.$route.params.map_id.split('-')[1],
                                block_id: this.$route.params.block_id
                                    ? this.$route.params.block_id.split('-')[1]
                                    : null,
                                note_type: this.$route.name,
                                location: this.noteLocation
                            }"
                            submit-text="Save Note"
                            @cancel="setUiMode('none')"
                            @success-complete="setUiMode('none')"
                            @success="onNoteCreated"
                        >
                            <m-textarea
                                label="Drag the yellow marker to a location on the map, and then enter your note below: "
                                name="text"
                                :model="model"
                                placeholder="eg. Finished here and did not start on other side of street."
                            ></m-textarea>
                        </ajax-form>
                    </div>
                </div>
            </transition>

            <transition name="slide">
                <div
                    v-if="
                        uiMode == 'view-note-details' &&
                            $store.getters.selectedId
                    "
                    id="div-view-note"
                    class="card"
                    style="position:fixed;top:55px;left:0px;width:100%;"
                >
                    <div class="card-body">
                        <div class="text-center font-weight-bold">
                            {{
                                new Date(
                                    $store.getters.singleSelection.timestamp
                                ).toLocaleString(undefined, {
                                    timeStyle: "short",
                                    dateStyle: "medium"
                                })
                            }}
                        </div>
                        <div class="text-center font-weight-bold">
                            From {{ $store.getters.singleSelection.user }}:
                        </div>
                        <div class="mb-3 text-center">
                            {{ $store.getters.singleSelection.text }}
                        </div>

                        <div class="row">
                            <div class="col-xs-6 pr-1 pl-3" style="width:50%">
                                <delete-confirm
                                    placement="bottom"
                                    :action="
                                        '/note/' +
                                            $store.getters.selectedId.split(
                                                '-'
                                            )[1]
                                    "
                                    @success="onDeleteNoteSuccess"
                                >
                                    Delete</delete-confirm
                                >
                            </div>
                            <div class="col-xs-6 pl-1 pr-3" style="width:50%">
                                <button
                                    type="button"
                                    class="form-control btn btn-primary"
                                    @click="clearSelectionAndUiModeNone"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <transition name="slide">
                <div
                    v-if="this.$route.name == 'block' && uiMode == 'remove-dnc'"
                    id="div-remove-dnc"
                    class="card"
                    style="position:fixed;top:55px;left:0px;width:100%;"
                >
                    <div class="card-body">
                        <ajax-form
                            v-slot="{ model }"
                            :action="`/mapdata/${$store.getters.selectedId}`"
                            method="PUT"
                            :hidden-input="{ do_not_call: 0 }"
                            @cancel="clearSelectionAndUiModeNone"
                            @success="updateDnc"
                            @success-complete="clearSelectionAndUiModeNone"
                        >
                            <m-textarea
                                label="Why should this DNC be removed? "
                                name="removal_details"
                                :model="model"
                                placeholder="eg. House Sold"
                            ></m-textarea>
                        </ajax-form>
                    </div>
                </div>
            </transition>

            <transition name="slide">
                <div
                    v-if="this.$route.name == 'block' && uiMode == 'view-dnc'"
                    id="div-show-dnc"
                    class="card"
                    style="position:fixed;top:55px;left:0px;width:100%;"
                >
                    <div class="card-body">
                        <div
                            @click="setUiMode('none')"
                            style="position:relative;"
                        >
                            <h4
                                class="icon-cancel"
                                style="position:absolute; right:0; top:0;font-size:largest;"
                            ></h4>
                            <h4 class="mb-3 text-center font-weight-bold">
                                DO NOT CALL
                            </h4>
                        </div>
                        <table class="table" id="dl-dnc">
                            <tr
                                v-for="(value, key) in $store.getters.dncList"
                                :key="key"
                            >
                                <th>{{ value.address }}</th>
                                <td>{{ value.details }}</td>
                            </tr>
                            <tr v-if="$store.getters.dncList.length == 0">
                                <th>
                                    There are no Do Not Calls on this block.
                                </th>
                            </tr>
                        </table>
                    </div>
                </div>
            </transition>
        </div>
    </main>
</template>

<script>
export default {
    data() {
        return {
            is_admin,
            csrf_token,
            user_name,
            uiMode: "none",
            errorMessage: null,
            pageTitle: "Loading Map, Please Wait...",
            noteLocation: null,
            loadingData: false,
            dataUrl: "",
            eTag: null,
            pollerId: null
        };
    },
    mounted: function() {
        if ("serviceWorker" in navigator) {
            // Handler for messages coming from the service worker
            navigator.serviceWorker.addEventListener(
                "message",
                this.onServiceWorkerMessage
            );
        }
        this.pollerId = setInterval(() => {
            if (document.hasFocus()) {
                this.loadMapData(false);
            }
        }, 15000);
    },
    beforeDestroy() {
        if ("serviceWorker" in navigator) {
            // Handler for messages coming from the service worker
            navigator.serviceWorker.removeEventListener(
                "message",
                this.onServiceWorkerMessage
            );
        }
        clearInterval(this.pollerId);
    },
    /*
    beforeRouteEnter(to, from, next) {
        // called when the route that renders this component has changed,
        // but this component is reused in the new route.
        // For example, for a route with dynamic params `/foo/:id`, when we
        // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
        // will be reused, and this hook will be called when that happens.
        // has access to `this` component instance.

        // the beforeRouteEnter function is called prior to the vue being created,
        // so we need to do our work in the next() callback which has access
        // to the component.

        console.log("beforeRouteEnter outside next V3", to, from);

        next(comp => {
            // bug on iPhone Safari, routing breaks
            if (comp.$route.params.map_id == "undefined") {
                next({ name: "list" });
            }

            console.log("beforeRouteEnter", comp.$route.params);
            if (comp.$route.params.map_id || comp.$route.params.block_id) {
                comp.dataUrl = `/mapdata/${comp.$route.params.map_id}`;
                if (to.name == "block") {
                    comp.dataUrl = `/mapdata/${comp.$route.params.block_id}`;
                }

                comp.loadMapData(true);
            } else {
                comp.dataUrl = "";
            }
        });
    },
    */
    watch: {
        $route: {
            handler: function(route) {
                console.log("watch $route V2");
                console.log(route);

                if (route.name == "block") {
                    if (route.params.block_id == "undefined") {
                        this.$router.replace({ name: "list" });
                    } else {
                        this.dataUrl = `/mapdata/${route.params.block_id}`;
                        this.loadMapData(true);
                    }
                } else if (route.name == "map") {
                    if (route.params.map_id == "undefined") {
                        this.$router.replace({ name: "list" });
                    } else {
                        this.dataUrl = `/mapdata/${route.params.map_id}`;
                        this.loadMapData(true);
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        onServiceWorkerMessage: function(event) {
            var eventUrl = new URL(event.data.url);
            if (
                event.data.type == "refresh" &&
                eventUrl.pathname == this.dataUrl &&
                event.data.eTag != this.eTag
            ) {
                this.loadMapData(false);
            }
        },
        loadMapData: function(zoomView) {
            if (!this.dataUrl) {
                return;
            }
            this.errorMessage = null;
            //var loadTimer = setTimeout(()=>{this.loadingData = true}, 1000);
            axios
                .get(this.dataUrl)
                .then(response => {
                    //clearTimeout(loadTimer);
                    this.loadingData = false;

                    // only update the store if the data has changed
                    if (this.eTag != response.headers.get("ETag")) {
                        this.$store.commit("clearMaps");
                        this.$store.commit("features", response.data.mapData);
                        this.$store.commit("features", response.data.noteData);

                        if (this.$route.name == "map") {
                            this.$store.commit("viewBlocks", true);
                            this.$store.commit("viewProperties", false);
                        } else {
                            this.$store.commit("viewBlocks", false);
                            this.$store.commit("viewProperties", true);
                        }

                        this.pageTitle = response.data.details.title;
                        this.eTag = response.headers.get("ETag");

                        // and zoom the view
                        if (zoomView) {
                            this.$store.commit("incView");
                        }
                    }
                })
                .catch(error => {
                    //clearTimeout(loadTimer);
                    this.loadingData = false;
                    this.errorMessage = error.message;
                    console.log(error);
                    console.log(error.response);
                });
        },
        clearSelectionAndUiModeNone() {
            this.setUiMode("none");
            this.$store.commit("attribute", {
                id: this.$store.getters.selectedId,
                attribute: "selected",
                value: false
            });
        },
        collapseNav: function() {
            $("#navbarSupportedContent").collapse("hide");
        },
        onMapSelect: function(selected) {
            var selectedFeature = this.$store.getters.singleSelection;

            if (
                selectedFeature.type == "note" &&
                this.$route.name == "map" &&
                selectedFeature.block
            ) {
                this.$router.push({
                    name: "block",
                    params: {
                        map_id: selectedFeature.map,
                        block_id: selectedFeature.block
                    }
                });
            } else if (selectedFeature.type == "note") {
                this.setUiMode("view-note-details");
            } else if (this.$route.name == "map") {
                this.$router.push({
                    name: "block",
                    params: {
                        map_id: selectedFeature.parent,
                        block_id: selectedFeature.id
                    }
                });
            } else {
                this.setUiMode("view-property-details");
            }
        },
        onMapDeselect: function(deselected) {
            this.setUiMode("none");
        },
        onNewNoteMoved: function(coords) {
            this.noteLocation = coords;
        },
        onNoteCreated: function(response) {
            this.$store.commit("feature", response.data);
        },
        onDeleteNoteSuccess: function(data) {
            this.setUiMode("none");
            this.$store.commit("deleteFeature", data.id);
        },
        setUiMode: function(mode) {
            this.collapseNav();
            // close existing menus and give time to animate collapse if they are open.
            if (this.uiMode != "none") {
                this.uiMode = "none";
                setTimeout(() => {
                    this.setUiMode(mode);
                }, 250);
            } else {
                this.uiMode = mode;
            }
            window.scrollTo(0, 0);
        },
        updateDnc(vals) {
            // this function is called on completion of DNC related
            // http transactions
            this.$store.commit("attribute", {
                id: vals.data.id,
                attribute: "do_not_call",
                value: vals.data.do_not_call
            });
        }
    }
};
</script>
